<script setup lang="ts">
import { computed } from "vue";

import { Batch } from "@/typings/batch";

const props = defineProps<{
  batch?: Batch;
}>();

const figures = computed(() => [
  { label: "Total Processing", value: props.batch?.processingItemCount },
  { label: "Total Completed", value: props.batch?.completedItemCount },
  {
    label: "Total Failed",
    value: props.batch?.failedItemCount,
    failed: true
  },
  { label: "Total Invoices", value: props.batch?.invoicesTotal },
  { label: "Total Payments", value: props.batch?.paymentsTotal }
]);
</script>

<template>
  <!-- Below md each figure is its own row. From md the wrappers take
       display: contents, so figures and dividers sit directly in one flex row. -->
  <div
    class="flex flex-col w-full md:w-auto md:flex-row batch-summary-stats rounded py-2 px-3"
  >
    <template v-for="(figure, index) in figures" :key="figure.label">
      <div v-if="index > 0" class="hidden md:contents">
        <divider vertical />
      </div>
      <div class="flex justify-between gap-2 md:contents">
        {{ figure.label }}:&nbsp;
        <strong :class="{ error: figure.failed }">{{ figure.value }}</strong>
      </div>
    </template>
  </div>
</template>

<style scoped lang="scss">
.error {
  color: var(--background-task-failed);
}
</style>
